import { inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Query } from '@datorama/akita';

import { BudgetState } from './budget.model';
import { BudgetStore } from './budget.store';

@Injectable({ providedIn: 'root' })
export class BudgetQuery extends Query<BudgetState> {
  budget_info = toSignal(
    this.select((state) => state.budget_info),
    { requireSync: true }
  );
  state = toSignal(this.select(), { requireSync: true });

  protected store: BudgetStore;

  constructor() {
    const store = inject(BudgetStore);

    super(store);

    this.store = store;
  }
}
